import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromBeverage from 'app/state/beverage';

export const beverageDetailResolverFn: ResolveFn<any> = (route, state) => {
  const store = inject(Store);
  store.dispatch(fromBeverage.setItem({ id: route.params['id'] ?? '' }));
  return true;
};
